import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Icon, StyledIconWrapper } from "@/components/Icon";
import { extensionNamesMap } from "@/containers/Converter/maps";
import { HowItWorksSteps } from "../types";

type IProps = { stepsData: HowItWorksSteps } & JSX.IntrinsicElements["div"];

export const StepWrapper: React.FC<IProps> = ({ stepsData }) => {
  const { css } = useFela();
  const { colors, bp } = useTheme();

  const { conversionType, steps } = stepsData;

  return (
    <div
      className={css({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: 20,
        [bp.FROM_TABLET]: {
          padding: "30px 44px",
        },
        [bp.FROM_DESKTOP]: {
          padding: "40px 64px",
        },
      })}
    >
      <div
        className={css({
          display: "flex",
          alignItems: "center",
        })}
      >
        <StyledIconWrapper
          wrapperStyle={{ width: 24, height: 24, marginRight: 8 }}
          customStyle={{ width: "100%", height: "100%" }}
        >
          <Icon iconType={stepsData.icon} />
        </StyledIconWrapper>
        <p className={css({ color: colors.DARK_GREY, fontWeight: 700 })}>
          {extensionNamesMap[conversionType]}
        </p>
      </div>
      {steps.map(({ id, title, text }) => (
        <div
          key={id}
          className={css({
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: 43,
          })}
        >
          <div
            className={css({
              position: "relative",
              marginBottom: 16,
            })}
          >
            <span
              className={css({
                position: "absolute",
                left: "calc(50% - 0.5px)",
                top: -23,
                height: 23,
                border: `.5px dashed ${colors.GRADIENT_PURPLE}`,
              })}
            />
            <span
              className={css({
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: 40,
                height: 40,
                backgroundColor: colors.GRADIENT_PURPLE,
                border: "2px solid rgba(0, 0, 0, 0.2)",
                borderRadius: "50%",
                fontWeight: 700,
                fontSize: 18,
                lineHeight: "26px",
                color: colors.WHITE,
              })}
            >
              {id + 1}
            </span>
          </div>
          <p
            className={css({
              marginBottom: 10,
              fontSize: 18,
              lineHeight: "26px",
              fontWeight: 700,
              letterSpacing: "0.5px",
              textAlign: "center",
            })}
          >
            {title}
          </p>
          <p
            className={css({
              color: colors.GRAY,
              fontSize: 14,
              lineHeight: "22px",
              textAlign: "center",
            })}
          >
            {text}
          </p>
        </div>
      ))}
    </div>
  );
};
